export default __webpack_public_path__ + "static/media/combot-green.8e72b90f.svg";